module.exports = __webpack_public_path__ + "static/media/HDQuali-logo-web-blue.cc1ac3be.png";